import Vue from 'vue'
import MapForm from './components/MapForm.vue'
import LocationForm from './components/LocationForm.vue'
import MapView from './components/MapView.vue'
import ShareBox from './components/ShareBox.vue'
import AreaForm from './components/AreaForm'
import BannerForm from './components/BannerForm'
import LayerForm from './components/LayerForm'
import ParcelMap from './components/ParcelMap'
import ParcelForm from './components/ParcelForm'
import SortingLayer from './components/SortingLayer'
import LocationTranslationForm from './components/LocationTranslationForm'
import SortingCategory from './components/SortingCategory'
import RouteForm from './components/RouteForm'
import GoogleAnalytics from './mixins/GoogleAnalytics'
import GeofenceForm from './components/GeofenceForm'
import AudioGuideForm from './components/AudioGuideForm'
import AudioGuidePlayer from './components/AudioGuidePlayer'
import IntroductionForm from './components/IntroductionForm'
import CongestionIconLevel from './components/CongestionIconLevel'
import CongestionSchedule from './components/CongestionSchedule'
import GraphForm from './components/GraphForm'
import HeatMap from './components/HeatMap'
import GtfsForm from './components/GtfsForm'
import Gtfs from './components/Gtfs'
import Dashboard from './components/Dashboard'
import SortingFacility from './components/SortingFacility'

Vue.mixin(GoogleAnalytics);
const app = new Vue({
    el: '#app',
    components: {
        MapForm,
        LocationForm,
        MapView,
        ShareBox,
        AreaForm,
        BannerForm,
        LayerForm,
        ParcelMap,
        ParcelForm,
        SortingLayer,
        LocationTranslationForm,
        SortingCategory,
        RouteForm,
        GeofenceForm,
        AudioGuideForm,
        AudioGuidePlayer,
        AudioGuidePlayer,
        IntroductionForm,
        CongestionIconLevel,
        CongestionSchedule,
        GraphForm,
        HeatMap,
        GtfsForm,
        Gtfs,
        Dashboard,
        SortingFacility,
    }
});
